export default __webpack_public_path__ + "static/media/mon_256.88734ac9.png";